import React from "react"

const NetworkDetailsContext = React.createContext({})

const { Provider, Consumer } = NetworkDetailsContext

export { Provider, Consumer, NetworkDetailsContext }
